import { FlagIcons } from '../Flags'

const CardFlag = ({ name, className, size, ...rest }) =>
  FlagIcons[name]({ size, className, ...rest })

export default CardFlag
